import { css } from 'styled-components';

import { COLORS } from '../colors';

// Bootstrap paints the tick with `background-image`, so it cannot inherit a colour — the greyed
// checkmark has to be its own asset. Inlined rather than shipped as a file because it is one path.
const GREY_CHECKMARK = `url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 20 20'%3e%3cpath fill='none' stroke='${encodeURIComponent(
  COLORS.GREY_35,
)}' stroke-linecap='round' stroke-linejoin='round' stroke-width='3' d='m6 10 3 3 6-6'/%3e%3c/svg%3e")`;

/**
 * A checkbox the user cannot act on right now (SWA-7965), wearing the same greys as a disabled
 * input: `GREY_32` border, `GREY_35` accent. Apply to the `:disabled` state; pair with
 * `lockedCheckedCheckboxMixin` for `:checked:disabled`, and grey the label with `GREY_35`.
 */
export const lockedCheckboxMixin = css`
  cursor: not-allowed;
  opacity: 1;
  accent-color: ${COLORS.GREY_35};
  border: 1px solid ${COLORS.GREY_32};
  background-color: transparent;
`;

/** The checked half of `lockedCheckboxMixin`: grey fill, grey tick. */
export const lockedCheckedCheckboxMixin = css`
  ${lockedCheckboxMixin};

  background-color: ${COLORS.GREY_29};
  background-image: ${GREY_CHECKMARK};
`;
